import { useQuery } from "react-query";
import { getUserTransactionCount } from "../api/transactions/getUserTransactionCount";
import { TRANSACTIONS_CACHE_KEY } from "./transactionsStore";

export const useQueryGetUserTransactions = () =>
  useQuery([TRANSACTIONS_CACHE_KEY, "tx-count"], () =>
    getUserTransactionCount()
  );
